import PropTypes from "prop-types";
import React from "react";
import desktopCheckMark from "../../assets/images/cropped-check-mark-circle.png";
import mobileCheckMark from "../../assets/images/full-check-mark-circle.png";
import { Button, H, Text } from "../../components";
/**
 *
 * @param {object} props
 * @param {string} props.email
 * @param {() => any} props.restart
 * @returns {JSX.Element}
 */

const ConfirmationScreen = ({
  email,
  restart
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "shadow-md w-full max-w-2xl py-4 md:py-0 flex flex-col md:flex-row justify-start items-center md:items-start bg-en-yellow-300 overflow-hidden rounded-lg"
  }, /*#__PURE__*/React.createElement("img", {
    src: mobileCheckMark,
    alt: "''",
    className: "md:hidden"
  }), /*#__PURE__*/React.createElement("img", {
    src: desktopCheckMark,
    alt: "''",
    className: "hidden md:block h-64"
  }), /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-center md:text-left"
  }, /*#__PURE__*/React.createElement(H, {
    level: 2
  }, "Success!"), /*#__PURE__*/React.createElement(Text, {
    variant: "secondary"
  }, `An email has been sent to ${email}.`), /*#__PURE__*/React.createElement(Text, {
    variant: "secondary"
  }, "Once access is granted, we'll send you a confirmation email. If you have any questions, don't hesitate to contact the customer success team at", " ", /*#__PURE__*/React.createElement("a", {
    className: "font-bold whitespace-nowrap",
    href: "mailto:support@enpowered.com"
  }, "support@enpowered.com")), /*#__PURE__*/React.createElement("div", {
    className: "text-center md:text-right mt-16"
  }, /*#__PURE__*/React.createElement(H, {
    level: 4
  }, "Have more accounts to upload?"), /*#__PURE__*/React.createElement(Button, {
    size: "narrow",
    theme: "dark",
    className: "text-xs mt-4",
    onClick: () => restart()
  }, "Upload Account"))));
};

ConfirmationScreen.propTypes = {
  email: PropTypes.string.isRequired,
  restart: PropTypes.func.isRequired
};
export default ConfirmationScreen;